import { render, staticRenderFns } from "./CategoriesHomeBlock.vue?vue&type=template&id=2624b514&"
import script from "./CategoriesHomeBlock.vue?vue&type=script&lang=js&"
export * from "./CategoriesHomeBlock.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesHomeBlock.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports